import { types } from "../../../types";

const initialState = {
    pagination: {
        data: [],
        per_page: 5,
    },
    listProviders: [],
    openForm: false,
    active: null,
};

export const providersReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.providersSetActive:
            return {
                ...state,
                active: action.payload,
            };
        case types.providersUnsetActive:
            return {
                ...state,
                active: null,
            };
        case types.showProviders:
            return {
                ...state,
                pagination: action.payload.pagination,
            };
        case types.showListProviders:
            return {
                ...state,
                listProviders: action.payload.list,
            };
        case types.providersOpenModal:
            return {
                ...state,
                openForm: true,
            };
        case types.providersCloseModal:
            return {
                ...state,
                openForm: false,
            };
        default:
            return state;
    }
};
